import {ragServiceClient} from './service'
import {
  RagAgentListRequest,
  RagBootstrapRequest,
  RagConversationCreateRequest,
  RagConversationDeleteRequest,
  RagConversationHistoryRequest,
  RagConversationPageRequest,
  RagConversationSendRequest,
  RagKnowledgeBaseCreateRequest,
  RagKnowledgeBaseDeleteRequest,
  RagKnowledgeBaseDetailRequest,
  RagKnowledgeBaseDocumentDeleteRequest,
  RagKnowledgeBaseDocumentPageRequest,
  RagKnowledgeBasePageRequest,
  RagKnowledgeBaseUpdateRequest,
  RagKnowledgeBaseUploadRequest,
  RagModel,
  RagModelCreateRequest,
  RagModelDeleteRequest,
  RagModelDetailRequest,
  RagModelPageRequest,
  RagModelProviderPageRequest,
  RagModelUpdateRequest,
  RagSharedSpaceCreateRequest,
  RagSharedSpaceInviteRequest,
  RagSharedSpaceMemberPageRequest,
  RagSharedSpacePageRequest,
  RagSharedSpaceRemoveMemberRequest
} from '../../../api/ragService_pb'

export {
  ragServiceClient,
  RagAgentListRequest,
  RagBootstrapRequest,
  RagConversationCreateRequest,
  RagConversationDeleteRequest,
  RagConversationHistoryRequest,
  RagConversationPageRequest,
  RagConversationSendRequest,
  RagKnowledgeBaseCreateRequest,
  RagKnowledgeBaseDeleteRequest,
  RagKnowledgeBaseDetailRequest,
  RagKnowledgeBaseDocumentDeleteRequest,
  RagKnowledgeBaseDocumentPageRequest,
  RagKnowledgeBasePageRequest,
  RagKnowledgeBaseUpdateRequest,
  RagKnowledgeBaseUploadRequest,
  RagModel,
  RagModelCreateRequest,
  RagModelDeleteRequest,
  RagModelDetailRequest,
  RagModelPageRequest,
  RagModelProviderPageRequest,
  RagModelUpdateRequest,
  RagSharedSpaceCreateRequest,
  RagSharedSpaceInviteRequest,
  RagSharedSpaceMemberPageRequest,
  RagSharedSpacePageRequest,
  RagSharedSpaceRemoveMemberRequest
}
